import { render, staticRenderFns } from "./ViewFormRF12.vue?vue&type=template&id=326bc9cc"
import script from "./ViewFormRF12.vue?vue&type=script&lang=js"
export * from "./ViewFormRF12.vue?vue&type=script&lang=js"
import style0 from "./ViewFormRF12.vue?vue&type=style&index=0&id=326bc9cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports